// extracted by mini-css-extract-plugin
export default {"cardDate":"CardDate_cardDate__-dycg"};